module.exports = __webpack_public_path__ + "fonts/fa-brands-400.764a8efb.eot";